import { format } from 'date-fns';

export const getMessage = params => {
  switch (params.type) {
    case 'required':
      return 'Field is required.';
    case 'requiredIf':
      return 'Field is required.';
    case 'email':
      return 'Not a valid email address.';
    case 'phone':
      return 'Not a valid phone number.';
    case 'minLength':
      return `Must be at least ${params.min} characters long.`;
    case 'maxLength':
      return `Must be less than ${params.max} characters long.`;
    case 'minValue':
      return `Must be at least ${params.min}.`;
    case 'maxValue':
      return `Must be less than ${params.max}.`;
    case 'validDate':
      return 'Not a valid date';
    case 'minimumDate':
      return `Must be on or after ${format(params.min, 'MMM d, yyyy hh:mm a')}`;
    case 'maximumDate':
      return `Must be on or before ${format(params.max, 'MMM d, yyyy hh:mm a')}`;
    case 'minDate':
      return `Must be after ${format(params.min, 'MMM d, yyyy')}`;
    case 'maxDate':
      return `Must be before ${format(params.max, 'MMM d, yyyy')}`;
    case 'match':
    case 'expiration':
    case 'cvv':
      return `${params.message}`;
    default:
      return params.message ? `${params.message}` : 'Unknown validation passed in';
  }
};

export default { getMessage };
